import React, { lazy, Suspense, useRef, useState } from 'react';
import { useVisibility } from '@wearejh/react-hooks/lib/useVisibility';

import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';
import { getAdvancedSettings } from '../advancedSettings';

import type { ProductsType } from './productsConfigAggregator';

type PageBuilderProductsProps = ProductsType;

const LazyProductGrid = lazy(() => import('./components/ProductGrid'));
const LazyProductCarousel = lazy(() => import('./components/ProductCarousel'));

/**
 * Return the PB Products
 * @param props
 * @constructor
 */
export function PageBuilderProducts(props: PageBuilderProductsProps) {
    /**
     * Lazy load the ProductGrid and ProductCarousel components
     */
    const ref = useRef<HTMLDivElement | null>(null);
    const [isReady, setReady] = useState(false);
    const options: IntersectionObserverInit = {
        rootMargin: '75px',
    };
    useVisibility(ref, setReady, options);

    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderProductsProps>(props);

    const productsClassNames = ['pageBuilderProductsGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        productsClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Row Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={productsClassNames}
            ref={ref}
        >
            {props.appearance === 'grid' && isReady && (
                <Suspense fallback="...">
                    <LazyProductGrid {...props} />
                </Suspense>
            )}
            {props.appearance === 'carousel' && isReady && (
                <Suspense fallback="...">
                    <LazyProductCarousel {...props} />
                </Suspense>
            )}
        </PageBuilderElementWrapper>
    );
}
